import { LogoContent, LogoContainer, IconContainer } from "./logo.style"

const Logo = (props) => {
    return (
        <LogoContent>
            <LogoContainer compact={props.compact}>
                <img src="/assets/images/kc-logo.webp" alt="kc-logo" />
            </LogoContainer>
            {/* For Desktop */}
            <IconContainer onClick={() => props.setCompact(Number(!props.compact))} compact={props.compact}>
                <img src="/assets/images/chev-left-arrow.webp" alt="arrow" />
            </IconContainer>
            {/* For Mobile */}
            <IconContainer mobile onClick={props.close}>
                <img src="/assets/images/chev-left-arrow.webp" alt="arrow" />
            </IconContainer>
        </LogoContent>
    )
}

export { Logo }
